import React, { Component } from "react";
import { Route, NavLink, Routes, Navigate } from "react-router-dom";
import { Layout, Menu, Drawer, notification, message } from "antd";
import { TrophyOutlined, LogoutOutlined, MenuOutlined, UserOutlined, CarryOutOutlined, DollarOutlined, DollarCircleFilled } from "@ant-design/icons";
import { connect } from "react-redux";
import logoHorizontal from "../../assets/logo.png";
import { logout } from "../../store/actions/user";
import Carreras from "./Carreras/Carreras";
import ScrollToTopItem from "../../Components/ScrollToTopItem";
import Corredores from "./Corredores/Corredores";
import Registros from "./Registros/Registros";
import Pagos from "./Pagos/Pagos";
import Devoluciones from "./Devoluciones/Devoluciones";

const { Header, Content, Sider, Footer } = Layout;

class Panel extends Component {
    state = {
        collapsed: false,
        drawerVisible: false,
        isMobile: window.innerWidth <= 1000,
    };

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth <= 1000 });
    };

    toggleDrawer = () => {
        this.setState((prevState) => ({ drawerVisible: !prevState.drawerVisible }));
    };

    onCollapse = (collapsed) => {
        this.setState({ collapsed });
    };

    logout = () => {
        this.props.logout().then((response) => {
            if (response.success === 1) {
                this.setState({ redirect: <Navigate to="/login" /> });
                notification.info({
                    message: "Se ha cerrado la sesión",
                });
            } else {
                message.warning(response.err);
            }
        });
    };

    render() {
        const { isMobile, drawerVisible, collapsed } = this.state;
        const current = this.props.location?.pathname || "/panel/carreras";

        if (this.state.redirect) {
            return this.state.redirect;
        }

        const siderMenuItems = [
            {
                key: `/panel/registros`,
                icon: <CarryOutOutlined />,
                label: <NavLink to={`/panel/registros`}>Registros</NavLink>,
            },
            {
                key: `/panel/pagos`,
                icon: <DollarOutlined />,
                label: <NavLink to={`/panel/pagos`}>Pagos</NavLink>,
            },
            {
                key: `/panel/devoluciones`,
                icon: <DollarCircleFilled />,
                label: <NavLink to={`/panel/devoluciones`}>Devoluciones</NavLink>,
            },
            {
                key: `/panel/corredores`,
                icon: <UserOutlined />,
                label: <NavLink to={`/panel/corredores`}>Corredores</NavLink>,
            },
            {
                key: `/panel/carreras`,
                icon: <TrophyOutlined />,
                label: <NavLink to={`/panel/carreras`}>Carreras</NavLink>,
            },
        ];

        return (
            <Layout id="sinfondo">
                <Header id="header-fixed">
                    <Menu
                        mode="horizontal"
                        selectedKeys={[current]}
                        style={{ height: "100%", display: "block", alignItems: "center", padding: isMobile ? '0' : '0 50px' }}
                        items={[
                            {
                                key: "logo",
                                label: (
                                    <img src={logoHorizontal} alt="Logo" id="img-logo" />
                                ),
                                id: "menuitem-izquierda",
                            },
                            !isMobile
                                ? {
                                    key: "logout",
                                    icon: <LogoutOutlined />,
                                    label: "Log Out",
                                    onClick: this.logout,
                                    id: "menuitem",
                                }
                                : {
                                    key: "menu",
                                    icon: <MenuOutlined />,
                                    label: "",
                                    onClick: this.toggleDrawer,
                                    id: "menuitem",
                                },
                        ]}
                    />
                </Header>

                <Layout>
                    {!isMobile ? (
                        // Sider for Desktop
                        <Sider
                            collapsible
                            collapsed={collapsed}
                            onCollapse={this.onCollapse}
                            style={{
                                marginTop: "64px",
                                minHeight: "calc(100vh - 64px)",
                            }}
                        >
                            <div
                                style={{
                                    overflowY: "scroll",
                                    height: window.innerHeight - 64 - 48,
                                    position: "sticky",
                                    zIndex: 1,
                                    top: '64px'
                                }}
                                className="hide-scrollbar"
                            >
                                <Menu
                                    mode="vertical"
                                    theme="dark"
                                    selectedKeys={[current]}
                                    items={siderMenuItems}
                                />
                            </div>
                        </Sider>
                    ) : (
                        // Drawer for Mobile
                        <Drawer
                            title="Menu"
                            placement="left"
                            onClose={this.toggleDrawer}
                            open={drawerVisible}
                            bodyStyle={{ padding: 0 }}
                            width={300}
                        >
                            <Menu
                                mode="vertical"
                                theme="light"
                                selectedKeys={[current]}
                                items={[
                                    ...siderMenuItems,
                                    {
                                        key: "logout",
                                        icon: <LogoutOutlined />,
                                        label: "Log Out",
                                        onClick: this.logout,
                                    },
                                ]}
                            />
                        </Drawer>
                    )}

                    <Layout>
                        <Content id="content" style={{ minHeight: "calc(100vh - 64px)", }}>
                            <ScrollToTopItem />
                            <Routes>
                                <Route path="carreras" element={<Carreras />} />
                                <Route path="corredores" element={<Corredores />} />
                                <Route path="registros" element={<Registros />} />
                                <Route path="pagos" element={<Pagos />} />
                                <Route path="devoluciones" element={<Devoluciones />} />
                            </Routes>
                        </Content>
                        <Footer style={{ textAlign: "center" }}>
                            Todos Somos Diferentes ©{new Date().getFullYear()}
                        </Footer>
                    </Layout>
                </Layout>
            </Layout>
        );
    }
}

export default connect(null, { logout })(Panel);